export const BASELINE_FILTER = "baseline";
export const FUTURE_FILTER = "future";
